export const getOrganizationBySubdomain = async () => {
  const fullDomain = window.location.host;
  const subdomainArray = fullDomain
    .split(".")
    .slice(0, fullDomain.includes("localhost") ? -1 : -2);

  return subdomainArray[0];
};

export const getOrganizationId = async () => {
  return (await localStorage.getItem("organizationId")) ?? "";
};

export const getSelectedOrganizationId = () => {
  return localStorage.getItem("organizationId") ?? "";
};

export const getSelectedOrganizationName = () => {
  return localStorage.getItem("organizationName") ?? "";
};

export const hasWorkingOrganization = () => {
  const organizationId = getSelectedOrganizationId();
  const organizationName = getSelectedOrganizationName();
  return Boolean(organizationId) && organizationName !== "admin";
};

export const getSuperAdmin = async () => {
  return localStorage.getItem("superAdmin") === "true";
};
